// Generated by CoffeeScript 1.10.0
var React, objectAssign;

React = require('react');

objectAssign = require('object-assign');

module.exports = React.createClass({
  displayName: "Container",
  render: function() {
    var children, defaultStyles, props, styles;
    defaultStyles = {
      maxWidth: '960px',
      marginLeft: 'auto',
      marginRight: 'auto'
    };
    styles = objectAssign(defaultStyles, this.props.style);
    children = this.props.children;
    props = objectAssign({}, this.props);
    delete props.children;
    delete props.style;
    return React.createElement("div", Object.assign({}, props, {
      "style": styles
    }), children, React.createElement("span", {
      "style": {
        display: 'block',
        clear: 'both'
      }
    }, ' '));
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/react-responsive-grid/dist/components/Container.js
// module id = 670
// module chunks = 114276838955818